export default __webpack_public_path__ + "static/carousel-hero-web-fd250f53422acaeffbcb56094e4aa1c5.png";